import axios from 'axios';
import { baseUrl } from '@/config';

export default {
  /**
   * 성능/운영분석 화면 / 과점 SQL 문 리스트를 가져온다.
   * @author {Yang}
   * @param  {[x]} params
   * objId, startDatetime, endDatetime / 시간 - 차트클릭 기준시간
   * @return {[json파일]}  [과점 SQL 문 리스트]
   */
  getOligopolyQueryList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oligopoly-query-list.do`, params);
  },
  /**
   * [getOligopolyQueryDetailSql 성능/운영분석 화면 / 과점 SQL 문 리스트의 상세보기(sql)를 가져온다.]
   * @author {name}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[json파일]}        [description]
   */
  getOligopolyQueryDetailSql(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oligopoly-query-sql-detail.do`, params);
  },
  /**
   * Disk Read 데이터를 조회한다.
   * @author {name}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[json파일]}        [description]
   */
  getDiskReadData(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-disk-read-data.do`, params);
  },
  /**
   * [getOracleDbuserList 성능/운영분석 화면 / Oracle+ - db유저 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[type]}        [description]
   */
  getOracleDbuserList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-dbuser-list.do`, params);
  },
  /**
   * [getOracleParameterList 성능/운영분석 화면 / Oracle+ - db 파라미터 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[type]}        [description]
   */
  getOracleParameterList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-parameter-list.do`, params);
  },
  /**
   * [getOracleUserConnInfoList 성능/운영분석 화면 / Oracle+ - 사용자 접속 정보 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[type]}        [description]
   */
  getOracleUserConnInfoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-user-conn-info-list.do`, params);
  },
  /**
   * [getOracleDatafileList 성능/운영분석 화면 / Oracle+ -datafile I/O 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[type]}        [description]
   */
  getOracleDatafileList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-datafile-list.do`, params);
  },
  /**
   * [getOraclebackupList 성능/운영분석 화면 / Oracle+ -backup 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[type]}        [description]
   */
  getOraclebackupList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-backup-list.do`, params);
  },
  /**
   * [getOraclebackupList Oracle+ -backup [현재 ㄷ리스트 조회]]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCurrentOraclebackupList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-oracle-backup-list.do`, params);
  },
  /**
   * [getOracleasmList 성능/운영분석 화면 / Oracle+ -asm 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params [objId, startDatetime, endDatetime]
   * @return {[type]}        [description]
   */
  getOracleasmList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-asm-list.do`, params);
  },
  /**
   * [getHostPerformanceList 성능/운영분석 화면 / Host 성능 리스트 조회]
   * @author {Yang}
   * @param  {[type]} params diskParams [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },],
   *  cpuMemoryParams [objId(sms의 obj이다.), startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]]
   * @return {[type]}        [description]
   */
  getHostPerformanceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-host-performance-list.do`, params);
  },
  /**
   * [getObjIdFromServerByIpaddress dbms의 address로 sms의 obj를 구한다. - 화면 : 성능/운영분석 - Host성능]
   * @author {Yang}
   * @param  {[type]} params [dbms의 address]
   * @return {[Integer]}        [Sms의 objId]
   */
  getObjIdFromServerByIpaddress(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-obj-id-from-server-by-ipaddress.do`, { ipaddress: params });
  },
  /**
   * [getTablespaceOracleList 공간사용률 - 오라클(테이블스페이스) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getTablespaceOracleList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-tablespace-oracle.do`, params);
  },
  /**
   * [getTablespaceOracleFileInfoList 공간사용률 - DB 파일 정보 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[type]} params [objId, queryId, parameterMap: {name : rscKey}]
   * @return {[type]}        [description]
   */
  getDbFileInfo(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-db-file-info.do`, params);
  },
  /**
   * [getDatafileOracleList 공간사용률 - 오라클(데이터파일) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getDatafileOracleList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-datafile-oracle.do`, params);
  },
  /**
   * [getExtentsOracleList 공간사용률 - 오라클(온라인 익스텐트) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getExtentsOracleList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-extents-oracle.do`, params);
  },
  /**
   * [getExtentsOracleList 공간사용률 - 오라클(온라인 익스텐트 / 현재) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getCurrentExtentsOracleList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-extents-oracle.do`, params);
  },
  /**
   * [getTablespaceMysqlList  공간사용률 - mysql 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getTablespaceMysqlList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-tablespace-mysql.do`, params);
  },
  /**
   * [getTablespaceMssqlList 공간사용률 - mssql 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getTablespaceMssqlList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-tablespace-mssql.do`, params);
  },
  /**
   * [getTablespaceTiberoList 공간사용률 - Tibro(테이블스페이스) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getTablespaceTiberoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-tablespace-tibero.do`, params);
  },
  /**
   * [getDatafileTiberoList 공간사용률 - Tibro(데이터파일) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getDatafileTiberoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-datafile-tibero.do`, params);
  },
  /**
   * [getTablespaceCubridList  분석 - 공간사용률 - Cubrid(볼륨기준) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getTablespaceCubridList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-tablespace-cubrid.do`, params);
  },
  /**
   * [getTablespaceCubridList  분석 - 공간사용률 - Cubrid(볼륨타입기준) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, rscInfoList: [{ rsctypeId:, rscId },]
   * @return {[type]}        [description]
   */
  getTablespaceCubridTypeList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-tablespace-type-cubrid.do`, params);
  },
  /**
   * [getDemonprocessOracleList 데몬프로세스[이력] - 오라클 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId]
   * @return {[type]}        [description]
   */
  getDemonprocessOracleList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-demonprocess-oracle.do`, params);
  },
  /**
   * [getCurrentDemonprocessOracleList 데몬프로세스[현재] - 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCurrentDemonprocessList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-demonprocess.do`, params);
  },
  /**
   * [getDemonprocessCubridBrokerList 데몬프로세스 - Cubrid(브로커) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId]
   * @return {[type]}        [description]
   */
  getDemonprocessCubridBrokerList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-demonprocess-dbsession-cubrid-broker.do`, params);
  },
  /**
   * [getDemonprocessCubridCasList 데몬프로세스 - Cubrid(CAS) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId]
   * @return {[type]}        [description]
   */
  getDemonprocessDbsessionCubridCasList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-demonprocess-dbsession-cubrid-cas.do`, params);
  },
  /**
   * [getDemonprocessCubridCasList 데몬프로세스/세션 - Cubrid(현재) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params
   * @return {[type]}        [description]
   */
  getCurrentCubridList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-demonprocess-dbsession-cubrid.do`, params);
  },
  /**
   * [getDemonprocessCubridCasList 데몬프로세스 - Mssql 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId]
   * @return {[type]}        [description]
   */
  getDemonprocessMssqlList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-demonprocess-mssql.do`, params);
  },
  /**
   * [getDemonprocessCubridCasList 데몬프로세스 - Tibero 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId]
   * @return {[type]}        [description]
   */
  getDemonprocessTiberoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-demonprocess-tibero.do`, params);
  },
  /**
   * [getDbsessionOracleSessionStatusList db세션 - oracle(세션현황) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId, parameterMap(orderby)]
   * @return {[type]}        [description]
   */
  getDbsessionOracleSessionStatusList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-dbsession-oracle-session-status.do`, params);
  },
  /**
   * [getDbsessionWaitEventList db세션 - oracle(wait 이벤트) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId]
   * @return {[type]}        [description]
   */
  getDbsessionWaitEventList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-dbsession-oracle-wait-event.do`, params);
  },
  /**
   * [getDbsessionOpenCursorList db세션 - oracle(커서) 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId, parameterMap(SQLTEXT, USERNAME)]
   * @return {[type]}        [description]
   */
  getDbsessionOpenCursorList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-dbsession-oracle-open-cursor.do`, params);
  },
  /**
   * [getDbsessionSqlQueryDetailList db세션 -  sql문 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [[objId, startDatetime, endDatetime, queryId, parameterMap]]
   * @return {[type]}        [description]
   */
  getDbsessionSqlQueryDetailList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-dbsession-sql-query.do`, params);
  },
  /**
   * [getDbsessionTiberoList db세션 - tibero 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId, parameterMap(orderby)]
   * @return {[type]}        [description]
   */
  getDbsessionTiberoList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-dbsession-tibero.do`, params);
  },
  /**
   * [getDbsessionMssqlList db세션 - mssql 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId, parameterMap(orderby)]
   * @return {[type]}        [description]
   */
  getDbsessionMssqlList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-dbsession-mssql.do`, params);
  },
  /**
   * [getDemonprocessDbsessionMysqlList db세션 , 데몬프로세스 - mysql 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[DbmsParamVO]} params [objId, startDatetime, endDatetime, queryId, parameterMap(orderby)]
   * @return {[type]}        [description]
   */
  getDemonprocessDbsessionMysqlList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-demonprocess-dbsession-mysql.do`, params);
  },
  /**
   * [getCurrentDbsessionList db세션 - 현재 리스트를 리턴한다.]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getCurrentDbsessionList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-dbsession.do`, params);
  },
  /**
   * 메모리 정보(성능 데이터)를 조회한다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getPerformanceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-performance-list.do`, params);
  },
  /**
   * Oracle+ > RAC 성능 및 이벤트 데이터를 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getOracleRacData(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-rac-data.do`, params);
  },
  /**
   * Oracle+ > RAC Instance의 rsc_key들을 가져온다.
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   * @author jda
   */
  getObjRscKeyList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-obj-rsc-key-by-oracle-rac.do`, params);
  },
  /**
   * [getDbmsDataList Oralce+ / db유저, 파라미터 [현재]]
   * @author {Yang}
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDbmsDataList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-executed-query-dbms-list.do`, params);
  },
  /**
   * [getCurrentOracleAsmList Oracle+ ASM 현재 데이터 출력]
   * @author {Yang}
   */
  getCurrentOracleAsmList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-oracle-asm-list.do`, params);
  },
  /**
   * [getCurrentOracleDataFileList Oracle+의 현재 데이터 파일 입출력을 출력한다.]
   * @author {Yang}
   */
  getCurrentOracleDataFileList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-oracle-datafile-list.do`, params);
  },
  /**
   * [getCurrentPerformanceList 노드>분석> 메모리 정보(현재) 를 출력한다.]
   * @author {Yang}
   */
  getCurrentPerformanceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-performance-list.do`, params);
  },
  /**
   * [getCurrenthostPerformanceList 노드>분석> HOST 성능 (현재) 를 출력한다.]
   * @author {Yang}
   */
  getCurrenthostPerformanceList(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-host-performance-list.do`, params);
  },
  /**
   * [getCurrentTablespace 노드>분석> 공간사용률 (현재) - 테이블스페이스]
   * @author {Yang}
   */
  getCurrentTablespace(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-tablespace.do`, params);
  },
  /**
   * [getCurrentTablespace 노드>분석> 공간사용률 (현재) - 데이터 파일]
   * @author {Yang}
   */
  getCurrentTableDatefile(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-datafile.do`, params);
  },
  /**
   * [getCurrentTablespaceMssql 노드>분석> 공간사용률 (현재) - cubrid -볼륨 타입 기준]
   * @author {Yang}
   */
  getCurrentTablespaceTypeCubrid(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-current-tablespace-type-cubrid.do`, params);
  },
  /**
   * [오라클] Lock 스냅샷 조회
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getOracleLockSnapthot(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-lock-snapshot.do`, params);
  },
  /**
   * [오라클] Dead Lock 스냅샷 조회
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getOracleDeadLockSnapthot(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-dead-lock-snapshot.do`, params);
  },
  /**
   * [오라클] Latch 스냅샷 조회
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getOracleLatchLockSnapthot(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-oracle-latch-lock-snapshot.do`, params);
  },
  /**
   * 현재 DB Lock 정보를 조회한다.
   * @author Ju
   * @param  {[type]} params [description]
   * @return {[type]}        [description]
   */
  getDbLockInfoByQuery(params) {
    return axios.post(`${baseUrl}/performance/analysis/database/get-db-lock-info-by-query.do`, params);
  },
};



// WEBPACK FOOTER //
// ./src/api/performance/database/database-table-info.js